import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import Sticky from 'Pods/Shared/Sticky'

import UserNavBarContent from './UserNavBarContent'

class UserNavBar extends React.Component {
  constructor() {
    super()

    this.state = {
      topOffset: 0,
      pageTopOffset: 0,
    }

    this.navBarRef = React.createRef()

    this.updateOffset = this.updateOffset.bind(this)
  }

  componentDidMount() {
    this.setState({
      topOffset: document.getElementById('navigation-header').clientHeight,
    })

    this.updateOffset()

    window.addEventListener('resize', this.updateOffset);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateOffset);
  }

  updateOffset() {
    this.setState({
      pageTopOffset: 0,
    })
  }

  render() {
    return (
      <Sticky
        className="user-profile__sticky"
        selfAdjustingWidth
        position="top"
        stickyOffset={this.state.topOffset + this.state.pageTopOffset}
        offset={this.state.topOffset + this.state.pageTopOffset}
        wrapperClassName="user-profile__sticky-wrapper"
      >
        <div
          className="card user-profile__sticky-card"
          id="user-profile-navigation"
          ref={this.navBarRef}
        >
          <UserNavBarContent
            activeTab={this.props.activeTab}
            redirectTagEvent={this.props.setActiveTab}
            counts={this.props.counts}
            categories={this.props.categories}
            locale={this.props.locale}
          />
        </div>
      </Sticky>
    )
  }
}

UserNavBar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  counts: PropTypes.shape({
    modelCount: PropTypes.number.isRequired,
    galleryCount: PropTypes.number.isRequired,
    tutorialCount: PropTypes.number.isRequired,
  }).isRequired,
  categories: PropTypes.object,
}

export default UserNavBar
